import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
export default class Testimonials {
    constructor() {
        this.section = document.querySelector('.components-block-testimonials');
        this.slider = this.section.querySelector('.swiper');
        this.navigationPrev = this.section.querySelector('.slider-button-prev');
        this.navigationNext = this.section.querySelector('.slider-button-next');
        this.pagination = this.section.querySelector('.swiper-pagination-nav');

        this.ready();
    }

    ready() {
        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination],
            grabCursor: true,
            slidesPerView: 1,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    pagination: {
                        el: this.pagination,
                        type: 'fraction',
                    },
                },
                1024: {
                    slidesPerView: 1,
                    pagination: '',
                },
            },
        });
    }
}

if (document.querySelector('.components-block-testimonials')) {
    new Testimonials();
}
